export type Option = {
  id: string;
  provider: "NS" | "BM" | "Helm" | "CYA";
  externalId: string;
  yacht: { id: string; media: string[]; name: string; modelName: string; operator?: { id: string; name: string } | null };
  startDate: string;
  endDate: string;
  expirationDate: string | null;
  isOption: boolean;
  ownedByHelm: boolean;
  offer: null | { id: number; offer: { id: string } };
  details?: { createdDate: string } | { creationDate: string };
  createdAt: string;
};

export const apiCreatedDate = (o: Option) => {
  if (!o.details) {
    return null;
  }

  return "createdDate" in o.details ? o.details.createdDate : o.details.creationDate;
};
